// API Configuration
const API_URL = process.env.REACT_APP_API_URL || 'https://certificatebackend-sepia.vercel.app';

// Export the API URL
export { API_URL };